export default {
  selectLanguage: "en",
  language: "EN",
  download_invoice: "DOWNLOAD INVOICE",
  invoice_status_waiting_payment: "Waiting Payment",
  invoice_status_paid: "Paid",
  invoice_status_overdue: "Overdue",

  invoice_number: "Invoice Number",
  invoice_date: "Invoice Date",
  invoice_due_date: "Invoice Due Date",

  invoice_from: "Invoice From",
  invoice_to: "Invoice To",

  product: "Product",
  amount: "Amount",
  total_summary: "Total Summary",
  summary: "Ringkasan",
  subtotal: "Subtotal",
  total_discount: "Total Discount",
  additional_discount: "Additional Discount",
  additional_fee: "Additional Fee",
  delivery_fee: "Delivery Fee",
  admin_fee: "Admin Fee",
  tax: "Tax",
  total: "Total",
  tax_included: "Tax Included",
  total_paid: "Total Paid",
  amount_due: "Amount Due",
  discount: "Discount",

  signature: "Signature",

  notes_terms: "Notes & Terms",
  notes: "Notes",
  terms_condition: "Terms & Condition",

  view_payment: "View Payment",
  error_title: "Something went wrong",
  error_description: "An error occurred. Please try again.",
  refresh: "Refresh",

  table_product: "Product",
  table_description: "Description",
  table_qty: "Quantity",
  table_price: "Price (Rp)",
  table_discount: "Discount",
  table_tax: "Tax",
  table_amount: "Amount (Rp)",

  materai_info:
    "The e-Materai is attached and will be visible when you download the invoice PDF",
};
